import { render } from "./AdressList.vue?vue&type=template&id=6e156ed8&scoped=true"
import script from "./AdressList.vue?vue&type=script&lang=js"
export * from "./AdressList.vue?vue&type=script&lang=js"

import "./AdressList.vue?vue&type=style&index=0&id=6e156ed8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e156ed8"]])

export default __exports__